import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

// ── 全局锁时区：客户端始终显示中国时间（CST / Asia/Shanghai）──────────
//   实现：monkey-patch Date.prototype 的 4 个 toLocale* 方法，给 options
//   塞入默认 timeZone=Asia/Shanghai。已显式指定 timeZone 的调用不受影响
//   （因为 ...opts 在后面，能覆盖默认值）。
//
//   这样所有 `new Date(x).toLocaleString('zh-CN', { hour12: false })` 类的
//   调用都自动按北京时区格式化，无需散点修改散落在各页面的格式化代码。
const CLIENT_TZ = 'Asia/Shanghai';
['toLocaleString', 'toLocaleDateString', 'toLocaleTimeString'].forEach(method => {
  const original = Date.prototype[method];
  Date.prototype[method] = function (locale, opts) {
    return original.call(this, locale, { timeZone: CLIENT_TZ, ...(opts || {}) });
  };
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
